import {Collection, Model, registerModelAttrType} from 'backbone'
import 'bui/helpers/backbone/relations'
import 'bui/helpers/backbone/attr-types'
import dayjs from 'dayjs'

registerModelAttrType('date', val=>{
    return dayjs(val)
})

export default class Sessions extends Collection {
	get url(){ return APP_API_PATH+'/sessions' }
	get model(){ return Session }

	fetch(opts={}){

		opts.data = opts.data || {}

		let q = new URLSearchParams(location.search)

		if( q.get('email') )
			opts.data.email = encodeURIComponent(q.get('email'))
			
		if( q.get('session') )
			opts.data.num = q.get('session')

		return super.fetch(opts)
	}
}

class Session extends Model {

	get attrTypes(){return {
		start_date: 'date',
		end_date: 'date'
	}}

	get collections(){ return {
		medform: MedForm
	}}

	get dateRange(){
		return this.get('start_date').format('MMMM D')+ '-'+this.get('end_date').format('D, YYYY')
	}

    get isAvailable(){ return this.get('status') == 'open' || this.get('waitlist_accepted') }
    get isFull(){ return this.get('status') == 'full' && !this.get('waitlist_accepted') }

	get requiresCreditCard(){ return this.get('rate') > 0 }
}

class MedForm extends Collection {

	get isComplete(){
        return this.length != 0 && this.progress == 100
    }

    get numComplete(){
        return this.map(model=>this.questionIsComplete(model)).filter(s=>s).length
    }

    get progress(){
        return Math.round(this.numComplete / this.length * 100)
    }

	questionIsComplete(m){
		let desired = String(m.get('desired'))
		let val = String(m.get('val'))

        return (m.get('must_be') && val===desired)
        || (!m.get('must_be') && val !== '' && !m.get('needs_comment'))
        || (val !== desired && !!m.get('comment'))
        || (val === desired )
    }

    get value(){
        return this.map((m, i)=>{
            return {
                id: m.id,
                val: m.get('val'),
                comment: m.get('comment') 
            }
        })
    }

	toJSON(){
		return this.value
	}
}

export class Result extends Model {

	get isAdult(){
		
		if( this.get('session') == '3' || this.isStaff ) return true

		let dob = this.get('dob')
		return dob && Math.abs(dayjs(dob).diff(new Date, 'year')) >= 18
	}

	get isStaff(){
		return (this.get('session')||'').match(/staff/i)
	}
}